const getElementAssemblyType = (elementType: ElementTypes): ElementTypes => {
  if (elementType === 'vertical_roof_slabs') return 'roof_slabs'
  else if (elementType === 'vertical_slabs') return 'slabs'
  else return elementType
}

export default getElementAssemblyType
